import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Button, Stepper, TextField } from '@chillout/ui'
import { SelectField } from '../../shared/SelectField'

const REASON_KEYS = ['customer_complaint', 'system_error', 'cashier_mistake', 'promotion', 'other'] as const

interface AdjustmentFormProps {
  delta: number
  onDeltaChange: (value: number) => void
  min: number
  max: number
  reason: string
  onReasonChange: (value: string) => void
  note: string
  onNoteChange: (value: string) => void
  canApply: boolean
  onApply: () => void
  stepperLabel: string
  countLabel: string
  decrementAccessibilityLabel: string
  incrementAccessibilityLabel: string
  countAccessibilityLabel: string
  reasonLabel: string
  reasonPlaceholder: string
  noteLabel: string
  notePlaceholder: string
  applyLabel: string
  disabled?: boolean
}

export function AdjustmentForm({
  delta,
  onDeltaChange,
  min,
  max,
  reason,
  onReasonChange,
  note,
  onNoteChange,
  canApply,
  onApply,
  stepperLabel,
  countLabel,
  decrementAccessibilityLabel,
  incrementAccessibilityLabel,
  countAccessibilityLabel,
  reasonLabel,
  reasonPlaceholder,
  noteLabel,
  notePlaceholder,
  applyLabel,
  disabled,
}: AdjustmentFormProps) {
  const { t } = useTranslation()

  const reasonOptions = REASON_KEYS.map((key) => ({
    label: t(`common.adjustmentReasons.${key}`),
    value: key,
  }))

  return (
    <View className="gap-6">
      <Stepper
        value={delta}
        onChange={onDeltaChange}
        min={min}
        max={max}
        label={stepperLabel}
        countLabel={countLabel}
        disabled={disabled}
        decrementAccessibilityLabel={decrementAccessibilityLabel}
        incrementAccessibilityLabel={incrementAccessibilityLabel}
        countAccessibilityLabel={countAccessibilityLabel}
      />

      <SelectField
        label={reasonLabel}
        value={reason}
        options={reasonOptions}
        placeholder={reasonPlaceholder}
        onValueChange={onReasonChange}
      />

      <TextField
        label={noteLabel}
        placeholder={notePlaceholder}
        value={note}
        onChangeText={onNoteChange}
        multiline
        maxLength={200}
      />

      <Button
        label={applyLabel}
        onPress={onApply}
        disabled={!canApply || disabled}
      />
    </View>
  )
}